import {
    ILoyaltyCertType,
    ILoyaltyCertTypeListItem,
    LoyaltyCertTypeResponseType
} from '@/entity/loyalty/loyaltyCert/loyaltyCertType/LoyaltyCertType.types';

export default class LoyaltyCertType implements ILoyaltyCertType {
    total: number;
    data: ILoyaltyCertTypeListItem[] = [];
    constructor(data: LoyaltyCertTypeResponseType) {
        console.log('data LoyaltyCertTypeResponseType :');console.log(data);console.log('------------------------------------------------------');

        this.total = data.total;
        if(data.data && data.data.length)
        {
            for (let i = 0; i < data.data.length; i++) {
                this.data.push(data.data[i]);
            }
        }
    }
}
